import axiosAuth from '../../axiosMain';

async function update(id, data) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }
  let response = await axiosAuth.post('/users/' + id, form);
  return response.data.data;
}

async function indexCompany(id) {
  let response = await axiosAuth.get('/company_users/' + id);
  return response.data.data;
}

export default {
  update,
  indexCompany,
};
